/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Share_Score_LabelInputs */

const bn_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোর`)
};

const de_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punktzahl`)
};

const el_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σκορ`)
};

const en_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const es_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntaje`)
};

const fr_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const hi_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंक`)
};

const hu_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontszám`)
};

const id_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor`)
};

const it_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punto`)
};

const ja_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スコア`)
};

const ko_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`점수`)
};

const nl_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scoren`)
};

const pl_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynik`)
};

const pt_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação`)
};

const ru_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Счет`)
};

const sv_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Göra`)
};

const tr_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gol`)
};

const uk_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оцінка`)
};

const vi_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm`)
};

const zh_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分数`)
};

const zh_hant_daily_share_score_label = /** @type {(inputs: Daily_Share_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分數`)
};

/**
* | output |
* | --- |
* | "Score" |
*
* @param {Daily_Share_Score_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const daily_share_score_label = /** @type {((inputs?: Daily_Share_Score_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Share_Score_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_daily_share_score_label(inputs)
	if (locale === "de") return de_daily_share_score_label(inputs)
	if (locale === "el") return el_daily_share_score_label(inputs)
	if (locale === "en") return en_daily_share_score_label(inputs)
	if (locale === "es") return es_daily_share_score_label(inputs)
	if (locale === "fr") return fr_daily_share_score_label(inputs)
	if (locale === "hi") return hi_daily_share_score_label(inputs)
	if (locale === "hu") return hu_daily_share_score_label(inputs)
	if (locale === "id") return id_daily_share_score_label(inputs)
	if (locale === "it") return it_daily_share_score_label(inputs)
	if (locale === "ja") return ja_daily_share_score_label(inputs)
	if (locale === "ko") return ko_daily_share_score_label(inputs)
	if (locale === "nl") return nl_daily_share_score_label(inputs)
	if (locale === "pl") return pl_daily_share_score_label(inputs)
	if (locale === "pt") return pt_daily_share_score_label(inputs)
	if (locale === "ru") return ru_daily_share_score_label(inputs)
	if (locale === "sv") return sv_daily_share_score_label(inputs)
	if (locale === "tr") return tr_daily_share_score_label(inputs)
	if (locale === "uk") return uk_daily_share_score_label(inputs)
	if (locale === "vi") return vi_daily_share_score_label(inputs)
	if (locale === "zh") return zh_daily_share_score_label(inputs)
	return zh_hant_daily_share_score_label(inputs)
});